import { render, staticRenderFns } from "./CompleteText.vue?vue&type=template&id=0b1ff3cd&scoped=true&"
import script from "./CompleteText.vue?vue&type=script&lang=js&"
export * from "./CompleteText.vue?vue&type=script&lang=js&"
import style0 from "./CompleteText.vue?vue&type=style&index=0&id=0b1ff3cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ff3cd",
  null
  
)

export default component.exports